import lazyWithRetry from 'tools/lazyWithRetry';

const component = lazyWithRetry(() => import(
	/* webpackChunkName: "ViolationTypeDashboardPage" */
	'pages/vehicle/ViolationType/ViolationTypeDashboardPage'));

export default [{ component, exact: true, path: '/violation_types/:violationTypeId' }];